export default {
  onlinePay: 'ការទូទាត់តាមអ៊ីនធឺណិត',
  selectPaymethod: 'ជ្រើសរើសវិធីបង់ប្រាក់',
  documentTitle: 'រង្វាន់របស់ខ្ញុំ',
  goPayment: 'បង់',
  waitPay: 'រង់ចាំការទូទាត់',
  specification: 'ទំហំ',
  customize: 'ជ្រើសរើសទំហំ',
  optional: 'ជម្រើស',
  required: 'ទាមទារ',
  addToCart: 'ដាក់ចូលរទេះ',
  theStoreIsClosed: 'ម៉ោងសម្រាករបស់ហាង',
  businessHours: '	ម៉ោងដំណើរការ',
  mon: 'ច័ន្ទ',
  tues: 'អង្គារ',
  wed: 'ពុធ',
  thur: 'ព្រហស្បត៍',
  fri: 'សុក្រ',
  sat: 'សៅរ៍',
  sun: 'អាទិត្យ',
  categories: 'ប្រភេទទំនិញ',
  viewCart: 'មើលរទេះទំនិញ',
  toSettle: 'ទៅការតាំងទីលំនៅ',
  clearAll: 'ច្បាស់លាស់',
  sureClearAll: 'តើ​អ្នក​ប្រាកដ​ជា​ចង់​លុប​រទេះ',
  del_product: 'តើអ្នកប្រាកដថាអ្នកមិនចង់បានវាទេ?',
  total: 'សរុប',
  subtotal: 'សរុប',
  paymentMethod: 'វិធីទូទាត់ប្រាក់',
  cash: 'លុយសុទ្ធ',
  VAT: 'ពន្ធ',
  orderSubmit: 'បញ្ជាទិញឥឡូវ',
  submitSuccessfully: 'ដាក់ស្នើបានជោគជ័យ',
  orderNumber: 'លេខបញ្ជាទិញ',
  orderTime: 'ពេលបញ្ជាទិញ',
  payTime: 'ពេលវេលាផ្តល់',
  reason: 'មូលហេតុ',
  cancelled: 'បានបោះបង់',
  completed: 'បានបញ្ចប់',
  paymentTitle: 'លទ្ធផលនៃការទូទាត់',
  know: 'ខ្ញុំទទួលបានហើយ',
  inclVAT: '	បូកពន្ធ',
  noWownowTip: 'បើក WOWNOW APP និង កម្មង់អាហារ',
  stopTip: 'កំពុងសម្រាក',
  table: 'លេខតុ',
  orderCode: 'លេចកូដកម្មង់',
  checkout: 'បញ្ជាទិញ',
  placeOrder: 'ទៅបញ្ជាទិញ',
  waitingTip: 'កំពុងរង់ចាំហាងបញ្ជាក់ការកម្មង់',
  merchantsTip: 'ហាងនិងទទួលការកម្មង់ឆាប់ៗនេះ',
  cancelledTip: 'សូមអភ័យទោស ការបញ្ជាទិញរបស់អ្នកត្រូវបានលុបចោល សូមទំនាក់ទំនងជាមួយម្ចាស់ហាងសម្រាប់ហេតុផលជាក់លាក់។',
  waitPayTip: 'ការបញ្ជាទិញរបស់អ្នកត្រូវបានដាក់ស្នើរ សូមបង់ប្រាក់ទាន់ពេលវេលា!',
  completedTip: 'ការបញ្ជាទិញជោគជ័យ សូមទទួលទានដោយរីករាយ!',
  orderSummary: 'បញ្ជីទំនិញ',
  maxTip: 'ជ្រើសរើសបានច្រើនបំផុតត្រឹម {count}',
  copySuccess: 'ចម្លងដោយជោគជ័យ',
  copyFail: 'ការចម្លងបានបរាជ័យ',
  pullDownToRefresh: "ច្រើនទៀត...",
  releaseToRefresh: "ច្រើនទៀត...",
  loadingText: "កំពុង​ផ្ទុក…",
  noTableTip: 'លេខតុមិនដំណើរការ សូមស្កេនម្តងទៀត',
  notOrder: 'ទំនិញខាងក្រោមមិនអាចទិញបានទេ សូមពិនិត្យមើលឡើងវិញ',
  orderDetail: 'ពត៍មានលម្អិតការបញ្ជាទិញ',
  cart: 'រទេះទំនិញ',
  orderListTitle: '	ការបញ្ជាទិញរបស់ខ្ញុំ',
  wait: 'ការបញ្ជាទិញដែលមិនទាន់សម្រេច',
  orderShowDown: 'បានបង្ហាញការបញ្ជាទិញទាំងអស់',
  amount: 'Amount',
  noOrder: 'មិនទាន់មានការបញ្ជាទិញទេ សូមធ្វើការបញ្ជាទិញឥឡូវនេះ!',
  orderList: 'បញ្ជីបញ្ជាទិញ',
  remark: 'សំណើរទៅកាន់ហាង',
  paymentChannelOrder: 'ឆានែលទូទាត់លេខ​លំដាប់',
  showOrderDetail: 'មើលព័ត៌មានលម្អិតនៃការបញ្ជាទិញ',
  successTitle: 'ការទូទាត់បានជោគជ័យ',
  downloadTips: 'សូមទាញយក APP ហើយប្រើ WowNow APP ដើម្បីបញ្ជាទិញ',
  orderCreated: 'លេខតារាងបច្ចុប្បន្នបានបង្កើតការបញ្ជាទិញមួយ។',
  shoppingCartChangeTip: 'ព័ត៌មានរទេះបានផ្លាស់ប្តូរ',
  confirm: 'បញ្ជាក់',
  cancel: 'លុបចោល',
  loginTips: 'ចូលទៅគណនី WOWNOW របស់អ្នកសម្រាប់បទពិសោធន៍អ្នកប្រើប្រាស់កាន់តែប្រសើរ',
  mustLogin: 'ហាងនេះគាំទ្រតែការទូទាត់តាមអ៊ីនធឺណិតប៉ុណ្ណោះ សូមចូល និងធ្វើការបញ្ជាទិញ',
  goLogin: 'ដើម្បីចូល',
  ordering: 'បញ្ជាផ្ទាល់',
  confirmOrder: 'បញ្ជាក់​ការ​បញ្ជាទិញ',
  login: 'បន្ទាប់ពីចូល',
  logined: 'ចូលបានជោគជ័យ',
  canUse: 'មានការទូទាត់តាមអ៊ីនធឺណិត',
  tips: 'ចំណាំ',
  cartExpired: 'ព័ត៌មានរទេះបានផុតកំណត់ហើយ',
  seletedPropertyText: 'គុណលក្ខណៈដែលបានជ្រើសរើស',
  changeLang: 'ជ្រើសរើសភាសា',
  needDownloadWownow: 'ត្រូវការទាញយក wownow APP',
  limit99copies: 'កំណត់ 99 ច្បាប់ចម្លងក្នុងមួយមុខទំនិញ',
  samePropertyLimit99: 'ផលិតផលដែលមានលក្ខណៈជាក់លាក់ ឬគុណលក្ខណៈដូចគ្នាត្រូវបានកំណត់ត្រឹម 99 ច្បាប់ចម្លងប៉ុណ្ណោះ។，បរិមាណបច្ចុប្បន្ន：{current}',
  plsSelectPayMethod: 'សូមជ្រើសរើសវិធីបង់ប្រាក់ជាមុនសិន',
  zh: 'ជនជាតិចិន',
  en: 'ភាសាអង់គ្លេស',
  km: 'ខ្មែរ'
}
